import React, { useState } from 'react';
import { observer } from 'mobx-react';
import MarkdownContent from '../CompanyPage/MarkdownContent';
import EditWrapper from '../CompanyPage/EditWrapper';
import CompanyOfferings from '../../components/CompanyOfferings/CompanyOfferings';
import {
  PageWrapper, PageHeader, PageTitle, EditButton, Card, CardHeader, CardTitle,
  DownloadLink, EmptyState, CardGrid,
} from '../CompanyPage/CompanyPage.styles';

const OfferingsPage = observer(({ company, mode }) => {
  const [editing, setEditing] = useState(false);
  const isReadonly = mode === 'readonly';
  const offerings = company?.offerings || [];

  if (editing) {
    return (
      <PageWrapper>
        <PageHeader>
          <PageTitle>Offerings</PageTitle>
        </PageHeader>
        <EditWrapper onBack={() => setEditing(false)}>
          <CompanyOfferings company={company} />
        </EditWrapper>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper data-tour="offerings-page">
      <PageHeader>
        <PageTitle>Offerings</PageTitle>
        {!isReadonly && (
          <EditButton onClick={() => setEditing(true)}>
            {'\u270E'} Edit
          </EditButton>
        )}
      </PageHeader>

      {offerings.length === 0 ? (
        <EmptyState>No offerings have been added yet.</EmptyState>
      ) : (
        <CardGrid>
          {offerings.map((item, i) => (
            <Card key={i}>
              <CardHeader>
                <CardTitle>{item.offering || `Offering #${i + 1}`}</CardTitle>
              </CardHeader>
              <MarkdownContent markdown={item.differentiator} />
              {item.uploadLink && (
                <div style={{ marginTop: 16 }}>
                  <DownloadLink href={item.uploadLink} target="_blank" rel="noopener noreferrer">
                    {'\u{1F4CE}'} Download Document
                  </DownloadLink>
                </div>
              )}
            </Card>
          ))}
        </CardGrid>
      )}
    </PageWrapper>
  );
});

export default OfferingsPage;
